export interface Category {
  id: number;
  name: string;
  displayName: string;
  url: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    displayName: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    displayName: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
  },
  {
    id: 3,
    name: 'T-Shirts',
    displayName: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
  },
  {
    id: 4,
    name: 'Jackets',
    displayName: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    displayName: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
  },
  {
    id: 6,
    name: 'Headwear',
    displayName: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
  },
  {
    id: 7,
    name: 'Sets',
    displayName: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
  },
  {
    id: 8,
    name: 'underwear/underpants',
    displayName: 'Underwear',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
  },
  {
    id: 9,
    name: 'Jersey',
    displayName: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
  },
  {
    id: 10,
    name: 'Accessories',
    displayName: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
  },
  {
    id: 11,
    name: 'Bags',
    displayName: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
  },
  {
    id: 12,
    name: 'Belts',
    displayName: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
  },
  {
    id: 13,
    name: 'Perfumes',
    displayName: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
  },
  {
    id: 14,
    name: 'OtherStuff',
    displayName: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
  },
];

export const featuredProducts = [
  {
    id: 1,
    title: 'Trending Sneakers',
    description: 'Latest finds from the kakobuy spreadsheet sneaker section',
    category: 'Shoes',
  },
  {
    id: 2,
    title: 'Premium Hoodies',
    description: 'Top-rated hoodies and sweaters handpicked from verified sellers',
    category: 'Hoodies & Sweaters',
  },
  {
    id: 3,
    title: 'Designer Bags',
    description: 'Quality bags and accessories sourced from trusted spreadsheet listings',
    category: 'Bags',
  },
];

export const faqItems = [
  {
    question: 'What is Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet is a comprehensive product directory that helps buyers discover, compare, and purchase items from verified sellers. It organizes thousands of products across multiple categories including shoes, clothing, accessories, and more, making it the go-to resource for informed shopping decisions.',
  },
  {
    question: 'Is Kakobuy Spreadsheet safe to use?',
    answer: 'Yes, Kakobuy Spreadsheet prioritizes buyer safety. We recommend checking seller ratings, reviewing QC (quality control) photos, reading buyer feedback, and using secure payment methods. Our buying guides provide detailed safety tips to ensure a secure shopping experience.',
  },
  {
    question: 'How do I find the best products on Kakobuy Spreadsheet?',
    answer: 'Start by browsing our category directory to find products you are interested in. Compare prices across different sellers, check product photos carefully, read descriptions thoroughly, and look for highly-rated sellers with positive feedback history.',
  },
  {
    question: 'How often is the Kakobuy Spreadsheet updated?',
    answer: 'The Kakobuy Spreadsheet directory is updated daily with new product listings, seller information, and the latest finds. We continuously monitor and refresh our database to ensure you have access to the most current product information available.',
  },
  {
    question: 'Can beginners use Kakobuy Spreadsheet?',
    answer: 'Absolutely! Kakobuy Spreadsheet is designed to be beginner-friendly. Our complete beginner guide walks you through every step of the process, from finding products to placing orders safely. No prior experience is needed to start discovering great finds.',
  },
];